



























































import Vue from 'vue'
import { Component, Config } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { MessageBoardCustomMessages } from '@/modules/common/message-board/models/message-board-custom-messages'
import { UserType } from '@/modules/user/models/user-resource.model'

export interface CustomMessageBoardCollection {
  text: string
  url?: string
  button_text?: string
  key: string,
  close: boolean
  type?: string
  color?: string
  bold?: boolean
  user_type?: UserType
  icon?: string
  noOutline?: boolean
}

@Component({
  components: { BaseButton }
})
export default class MessageBoard extends Vue {
  customMessages: CustomMessageBoardCollection[] = MessageBoardCustomMessages()
  keyPrefix = 'niknevis_message_'
  userType: UserType = Config.get('userType')

  mounted() {
    this.clearLocalStorageMessages()
  }

  //Methods
  showMessage(message) {
    return !(localStorage.getItem(this.keyPrefix + message.key)) || !message.close
  }

  onClose(message) {
    localStorage.setItem(this.keyPrefix + message.key, '1')
    document.getElementById(message.key).style.display = 'none'
  }

  clearLocalStorageMessages() {
    let keyPrefix = this.keyPrefix
    let result = this.customMessages.map(item => keyPrefix + item.key)
    Object.keys(localStorage).forEach(function(key) {
      if (!result.includes(key)) {
        if (key.includes(keyPrefix)) localStorage.removeItem(key)
      }
    })
  }

  background(type) {
    if (type === 'warning') {
      return 'bg-tes-gradient-orange'
    } else if (type === 'success') {
      return 'bg-tes-gradient-green'
    } else if (type === 'info') {
      return 'bg-tes-gradient-blue'
    } else if (type === 'danger') {
      return 'bg-tes-gradient-red'
    }
  }
}

